<!-- 销售单急件商品列表-->
<template>
    <div id="urgentGoodList" class="business-content-main urgentGoodPur">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.stockPurchase" @click="gotoQuickBuy()">{{ permission.stockPurchase }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">客户名称</div>
                <div class="search-item goods-categories">
                    <el-select
                        style="width: 100%"
                        size="small"
                        v-model="searchData.CusName"
                        remote
                        filterable
                        allow-create
                        clearable
                        placeholder="请输入客户名称"
                        :remote-method="searchCustom"
                        v-select-scroll-more="searchCustomLoad"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">
                                    {{ ` ( 电话：${item.CallNum} )` }}
                                </span>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配编码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode" placeholder="请输入汽配编码"></el-input>

                <div class="search-name">采购状态</div>
                <div class="search-item goods-categories">
                    <el-select v-model="searchData.State" filterable clearable size="small" style="width: 100%">
                        <el-option :key="item.Value" v-for="item in purStates" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                </div>

                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    ref="multipleTable"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :cell-style="cellStyle"
                    @selection-change="handleSelectionChange"
                    @cell-dblclick="handleDBClick"
                >
                    <el-table-column fixed type="selection" width="55" :selectable="selectInit"></el-table-column>
                    <el-table-column min-width="150px" prop="SaleOrderCode" label="关联销售单" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="150px" prop="CusName" label="客户名称" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="200px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="150px" prop="GoodName" label="汽配名称" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="200px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" label="产地" prop="Origin" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" prop="Brand" label="品牌" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" prop="Cate" label="汽配分类" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="SalesCount" label="销售数" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="Price" label="销售单价" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" prop="TotalPrice" label="销售总额" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" prop="LastUPurPrice" label="最新急件价" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="150px" prop="WarehouseName" label="出仓仓库" show-overflow-tooltip></el-table-column>
                    <!-- <el-table-column min-width="150px" prop="PurStateName" label="采购状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.PurOrderCode == '' ? '未采购' : '已采购' }}
                        </template>
                    </el-table-column> -->
                    <el-table-column min-width="150px" prop="PurStateName" label="采购状态" show-overflow-tooltip> </el-table-column>
                    <el-table-column min-width="100" prop="PurOrderCode" label="关联采购单" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="150" prop="ConfirmTime" label="提交时间" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="closeAPMsgDialog"> </APMsg>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory
                    :EntpTempGoodsId="EntpTempGoodsId"
                    :EntpCusId="EntpCusId"
                    :EntpCusName="EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="EntpTempGoodsId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="更多条件搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-page-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item label="联合查询">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            size="small"
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="汽配编码">
                        <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <el-select
                            ref="search_cus"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.CusName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="客户名称/电话"
                            :remote-method="searchCustom"
                            v-select-scroll-more="searchCustomLoad"
                        >
                            <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                <div class="name">
                                    {{ item.EntpCusName }}
                                    <span v-if="item.CallNum" class="phone">
                                        {{ ` ( 电话：${item.CallNum} )` }}
                                    </span>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售单号">
                        <el-input size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="销售单号"></el-input>
                    </el-form-item>
                    <el-form-item label="出库仓库">
                        <el-select size="small" style="width: 100%" v-model="searchData.WarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                            <el-option
                                v-for="optionItem in warehouseList"
                                :key="optionItem.WarehouseId"
                                :label="optionItem.WarehouseName"
                                :value="optionItem.WarehouseId"
                            >
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购状态">
                        <el-select v-model="searchData.State" filterable clearable size="small" style="width: 100%">
                            <el-option :key="item.Value" v-for="item in purStates" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-autocomplete
                            ref="search_9"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Origin"
                            :fetch-suggestions="searchOrigin"
                            :debounce="500"
                            placeholder="请输入产地信息"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchOriginLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="提交时间">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime3"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate3TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import APMsg from '@/components/common/APMsg';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'urgentGoodList',
    components: {
        APMsg,
        elTableColumn,
        APPurchaseHistory,
        APHistory,
        goodsAnalysis,
        breadcrumb
    },
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    data() {
        return {
            multipleSelection: [],
            purStates: [
                { Value: '', Text: '全部' },
                { Value: '0', Text: '未转换' },
                { Value: '1', Text: '已转换' }
            ],
            loading: false,
            brand: [],
            noData: false,
            typeList: [],
            APMsgVisible: false,
            EntpTempGoodsId: '',
            showSaleStatDialog: false,
            eyeHistoryVisible: false,
            goodsAnalysisVisible: false,
            SaleDialogTitle: '',
            historyVisible: false,
            searchData: {
                State: '0',
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                JointSearch: '',
                CusName: '',
                OrderCode: '',
                WarehouseId: '',
                Origin: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: 15,
                SearchType: 2
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            isAddWaitIn: true,
            EntpCusId: '',
            EntpCusName: '',
            isLatelyPrice: false,
            dialogVisible: false,
            separator: '',
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            warehouseList: [],
            originOptions: [],
            originForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            canSearch: true,
            datetime3: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();

                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 335);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
        //切换页面的时候不会清除当前页面缓存，但是其他页面也有相同字段，会串页面数据，还是把数据清空了不要误导
        this.$refs.multipleTable.clearSelection();
        // this.idList = [];
        this.multipleSelection = [];
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        // document.addEventListener('keydown', this.handleKeyEvent);
        this.getJointSearchSets();
    },
    mounted() {
        // this.getConfigByCodes();
        this.getTableData();
        this.permission = this.$util.getPermission('urgentGoodsPur');
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
            }
            if (key === 27) {
                if (that.dialogVisible) that.dialogVisible = false;
            }
            if (key === 13) {
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                if (this.searchData.Page > 1) {
                    this.searchData.Page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                if (this.searchData.Page < Math.ceil(this.tableDataLength / this.searchData.Limit)) {
                    this.searchData.Page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 单元格的 style 的回调方法
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (column.label === '操作') {
                return `background:#FFF;`;
            } else {
                return '';
            }
        },
        // 跳转直接采购
        gotoQuickBuy() {
            if (!this.multipleSelection[0]) {
                this.$router.push('/purchaseManage/urgentGoodsToPur');
                return;
            }
            let dataList = [];
            let warehouseId = '';
            for (var i = 0; i < this.multipleSelection.length; i++) {
                let data = { ...this.multipleSelection[i] };
                if (i == 0) warehouseId = data.WarehouseId;
                else {
                    if (warehouseId != data.WarehouseId) {
                        this.$util.warningMsg('请选择相同出仓仓库的急件进行采购');
                        return;
                    }
                }

                if (data.LatelyPurchase) {
                    data.EntpCusId = data.LatelyPurchase.EntpCusId;
                    data.EntpCusName = data.LatelyPurchase.EntpCusName;
                    data.EntpCusItem = data.LatelyPurchase.EntpCusName;
                    data.LatelyPrice = data.LatelyPurchase.Price;
                    // data.Price = data.LatelyPurchase.Price > 0 ? data.LatelyPurchase.Price : data.Price;
                    data.Price = data.LatelyPurchase.Price > 0 ? data.LatelyPurchase.Price : data.CostPrice;
                    this.$delete(data, 'LatelyPurchase');
                } else {
                    data.EntpCusId = '';
                    data.EntpCusName = '';
                    data.EntpCusItem = '';
                    data.LatelyPrice = 0;
                    data.Price = data.CostPrice;
                }
                data.Count = data.SalesCount;
                data.GoodNameItem = data.GoodName;
                data.AutoSeriseItem = data.AutoSerise;
                dataList.push(data);
            }
            if (dataList.length > 0) this.$util.setLocalStorage('AddUrgentGoodsPur_dataList', dataList);
            this.$router.push('/purchaseManage/urgentGoodsToPur');
        },

        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                State: '0',
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                JointSearch: '',
                CusName: '',
                OrderCode: '',
                WarehouseId: '',
                Origin: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: this.commonPageSize,
                SearchType: 2
            };
            this.datetime3 = [];
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/GetSaleUrgentGoodsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        this.tableDataLength = 0;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    if (this.searchData.page == 1) this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.EntpTempGoodsId) {
                this.EntpTempGoodsId = event.EntpTempGoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        //当汽配分类下拉框出现时触发
        cateVisibleChange() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        gotoOldVers() {
            this.$router.push('/purchaseManage/stockPurchase');
        },
        //销售数据
        showSaleStat(row, LatelyPurchase) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.EntpTempGoodsId = row.EntpTempGoodsId;
                if (LatelyPurchase) {
                    this.EntpCusId = LatelyPurchase.EntpCusId;
                    this.EntpCusName = LatelyPurchase.EntpCusName;
                } else {
                    this.EntpCusId = '';
                    this.EntpCusName == '';
                }
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.EntpTempGoodsId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        // 历史销售
        showHistories(id, LatelyPurchase) {
            if (id) {
                this.EntpTempGoodsId = id;
                if (LatelyPurchase) {
                    this.EntpCusId = LatelyPurchase.EntpCusId;
                    this.EntpCusName = LatelyPurchase.EntpCusName;
                } else {
                    this.EntpCusId = '';
                    this.EntpCusName == '';
                }
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        getConfigByCodes() {
            let codes = ['lybsdr', 'dgystjqzdjg'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'lybsdr': //获取留余的计算方式
                                this.isAddWaitIn = !result;
                                break;
                            case 'dgystjqzdjg': //是否只取相同最低价格取最新供应商（返回最低价格）
                                this.isLatelyPrice = result;
                                break;
                        }
                    }
                }
            });
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    that.$util.getWarehouse(1).then(data => {
                        that.warehouseList = data;
                    });
                }
            }
        },
        searchOrigin(key, cb) {
            if (![undefined].includes(key)) {
                this.originForm.Page = 1;
                this.originForm.stopLoad = false;
                this.originForm.key = key;
                this.originOptions = [];
            }
            if (cb) {
                this.originCallBack = cb;
            }
            if (this.originForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.originForm.key, 3, this.originForm.Page, this.originForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.originForm.stopLoad = data.length < this.originForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.originOptions = [...this.originOptions, ...arr];
                if (this.originCallBack) {
                    this.originCallBack(this.originOptions);
                }
            });
        },
        searchOriginLoad() {
            this.originForm.Page += 1;
            this.searchOrigin();
        },
        stopSearch() {
            this.canSearch = false;
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        selectInit(row, index) {
            return !row.UrgentPurId;
        }
    }
};
</script>
<style lang="less" scoped>
.qp-msg {
    padding-bottom: 10px;

    p {
        padding-top: 10px;
    }
}

.qp-ctn {
    display: flex;
    flex-wrap: wrap;
}

.qp-item {
    width: 250px;
    margin-right: 20px;
    margin-bottom: 20px;
}

.qp-cover {
    text-align: center;
    overflow: hidden;

    img {
        max-height: 218px;
        max-width: 218px;
    }
}

.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }

    .image-cus {
        width: 25px;
        height: 25px;
    }
}

@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}

@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
</style>
<style lang="less">
.urgentGoodPur {
    .el-table {
        .hover-row > td,
        .el-table__row:hover > td {
            background-color: #dcdee1;
        }
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-table .error-row {
        background: rgb(255, 176, 176);
    }
}
</style>
